// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress{background-color:#e9ecef;border-radius:.25rem;display:flex;font-size:.75rem;height:1rem;overflow:hidden;padding:1px}.progress .progress-bar{background-color:#007bff;border-radius:.25rem;color:#fff;display:flex;flex-direction:column;justify-content:center;text-align:center;transition:width .6s ease;white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
